
import { Component, Vue, Prop } from "vue-property-decorator";
import { formatUpyunUrl } from "@/utils";
import { goEnroll } from "@/apis/home";
@Component({
  components: {}
})
export default class Course extends Vue {
  formatUpyunUrl = formatUpyunUrl;
  list = [];
  // 点击切换
  handleBtn(key: any) {
    this.$emit("changeCourse", key);
  }
  // 点击更多
  handleMore() {
    this.$router.push(`/course?tag=2`);
  }

  created() {
    this.getList();
  }

  async getList() {
    const { data } = await goEnroll({
      ext_type: 2,
      page: 1,
      per_page: 4
    });
    this.list = data || [];
  }

  ///course-detail?course_id=16006
  toDetail(item: any) {
    this.$router.push(`/course-detail?course_id=${item.course_id}`);
  }
}
